"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.wizard.title': 'Asistente de Onboarding',
    'onboarding.wizard.reset': 'Reiniciar',
    'onboarding.wizard.loading': 'Cargando...',
    'onboarding.wizard.step.progress': 'Paso {current} de {total}',
    'onboarding.wizard.tab.profession': 'Elegir Profesión',
    'onboarding.wizard.tab.steps': 'Completar Pasos',
    'onboarding.wizard.tab.review': 'Revisar',
    'onboarding.wizard.tab.completed': 'Completado',
    'onboarding.wizard.profession.title': 'Elija Su Profesión',
    'onboarding.wizard.profession.subtitle': 'Seleccione la profesión que mejor se adapte a su rol para obtener pasos de onboarding personalizados.',
    'onboarding.wizard.profession.select': 'Seleccionar',
    'onboarding.wizard.profession.selected': 'Seleccionado',
    'onboarding.wizard.profession.continue': 'Continuar con {profession}',
    'onboarding.wizard.profession.loading': 'Cargando profesiones...',
    'onboarding.wizard.profession.empty': 'No hay profesiones disponibles. Por favor contacte a su administrador.',
    'onboarding.wizard.navigation.previous': 'Anterior',
    'onboarding.wizard.navigation.next': 'Siguiente Paso',
    'onboarding.wizard.navigation.complete': 'Completar Onboarding',
    'onboarding.wizard.navigation.backToSteps': 'Volver a los Pasos',
    'onboarding.wizard.navigation.confirmComplete': 'Confirmar y Completar',
    'onboarding.wizard.questions.placeholder': 'Ingrese su respuesta...',
    'onboarding.wizard.questions.required': '*',
    'onboarding.wizard.questions.selectOption': 'Por favor seleccione una opción...',
    'onboarding.wizard.questions.empty': 'No hay preguntas disponibles para este paso.',
    'onboarding.wizard.review.title': 'Revise Su Onboarding',
    'onboarding.wizard.review.subtitle': 'Por favor revise sus respuestas antes de completar el proceso de onboarding.',
    'onboarding.wizard.review.profession': 'Profesión Seleccionada',
    'onboarding.wizard.review.steps': 'Pasos Completados',
    'onboarding.wizard.review.notSelected': 'No seleccionado',
    'onboarding.wizard.completed.title': '¡Onboarding Completado!',
    'onboarding.wizard.completed.message': '¡Felicitaciones! Ha completado exitosamente el proceso de onboarding para {profession}.',
    'onboarding.wizard.completed.fallback': 'su profesión',
    'onboarding.wizard.completed.startNew': 'Iniciar Nuevo Onboarding',
};
